import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'LinkPriceListItem',
    returnTo: 'LinkPriceListItems'
  }),
  created() {
    this.$store.dispatch('linkPriceListItem/getItems'); //, { query: { domainid: +this.$route.params.domainID } });
    this.$store.dispatch('priceListItem/getItems', { query: { domainid: +this.$route.params.domainID } });
    this.$store.dispatch('linkDomainProductGroup/getItems', { query: { domainid: +this.$route.params.domainID } });
  },
  methods: {
    getFinishTypeCascader() {
      return this.$store
        .dispatch('finishType/getFinishTypeCascader', {
          domainID: +this.$route.params.domainID,
          productGroupID: +this.$route.params.productGroupID
        })
        .then(data => {
          return data;
        });
    },
    getDependencies(data) {
      return [];
    },
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
